module.exports = __webpack_public_path__ + "img/no-car.64edfd3c.png";